import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { getShiftDuties, getShiftDutyById } from "../features/shift/shiftSlice";
import ShiftMemberDetails from "../components/shift/shift-member-details";
import LoadingSpinner from "../components/common/Loading";
import ProfileImage from "../assets/images/profileImage.svg";
import { Roles, ShiftTypes } from "../utils/constants";
import { styles } from "../components/shift/styles";
import { SHIFTMANAGEMENT_DASHBOARD_SCREEN_ROUTE } from "../routes";
import {
    extractDate, computeShiftStatus, calculateHoursDifference, getTimeFromISOString,
    filterCheckInsByWeek
} from "../utils/utils";

const ShiftUserScreen = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const pharmacyID = Number(localStorage?.getItem("pharmacyId"));
    const [selectedMember, setSelectedMember] = useState<any>(null);
    const [showMember, setShowMember] = useState(false);
    const {
        isAddShiftDutySuccess,
        isAddShiftDutyLoading,
        isDeleteShiftDutyLoading,
    }: any = useAppSelector((state) => state.shift);

    const userId = Number(useParams().userId) || -1;
    const GetAllDutiesByID = useCallback(() => {
        dispatch(getShiftDuties(pharmacyID))
        dispatch(getShiftDutyById({ pharmacy_id: pharmacyID, staff_id: userId }))
        // dispatch(getShiftDuties(15))
        // dispatch(getShiftDutyById({ pharmacy_id: 15, staff_id: userId }))
    }, [dispatch]);

    useEffect(() => {
        if (pharmacyID) {
            GetAllDutiesByID();
        }
    }, [pharmacyID, GetAllDutiesByID, isAddShiftDutySuccess, isAddShiftDutyLoading, isDeleteShiftDutyLoading]);

    const {
        shiftDutiesPayload,
        shiftDutyByIdPayload,
        isGetShiftDutyByIdLoading,
    }: any = useAppSelector((state) => state.shift);
    const dutyStaffPayload = shiftDutiesPayload?.staff_duty_with_roles?.find((item: any) => {
        return item?.pharmacyStaff?.id === String(userId);
    });
    const filterByWeek = filterCheckInsByWeek(shiftDutyByIdPayload?.acitvity)
    const dataList = filterByWeek?.map((item: any) => {
        const hoursDifference = calculateHoursDifference(item?.check_in, item?.check_out);
        return {
            check_in: getTimeFromISOString(item?.check_in),
            check_out: item?.check_out === null ? "-" : getTimeFromISOString(item?.check_out),
            shift_hours: item?.check_out === null ? "-" : hoursDifference === 0 ? `0 hrs` : `${hoursDifference} hrs`,
            shift_type: item?.shift_type === null ? "-" : ShiftTypes[(item?.shift_type)]?.charAt(0)?.toUpperCase() + ShiftTypes[(item?.shift_type)]?.slice(1)?.toLowerCase() + " Shift",  // Shift type or fallback
            shift_status: computeShiftStatus(dutyStaffPayload?.start_time, dutyStaffPayload?.end_time, item?.check_in, item?.check_out),
            timings: item?.shift_start_time === null || item?.shift_end_time === null ? "-" : `${item?.shift_start_time}-${item?.shift_end_time}`,
            date: extractDate(item?.check_in),
        }
    })
    const activityLatest = filterByWeek?.[filterByWeek?.length - 1]
    const check_in = activityLatest?.check_in
    const check_out = activityLatest?.check_out
    // Shift status
    const bannerDetails = {
        avatar: ProfileImage,
        name: dutyStaffPayload?.pharmacyStaff?.name,
        email: dutyStaffPayload?.pharmacyStaff?.email,
        timings: `${dutyStaffPayload?.start_time}-${dutyStaffPayload?.end_time}`,
        phone_number: dutyStaffPayload?.pharmacyStaff?.contact_number,
        address: dutyStaffPayload?.pharmacyStaff?.address,
        shift_status: computeShiftStatus(dutyStaffPayload?.start_time, dutyStaffPayload?.end_time, check_in, check_out),
        last_login: filterByWeek?.length > 0 && filterByWeek !== undefined ? getTimeFromISOString(filterByWeek?.[filterByWeek?.length - 1]?.check_in) : "-",
        role: Roles[dutyStaffPayload?.pharmacyStaff?.role?.role]?.charAt(0)?.toUpperCase() + Roles[dutyStaffPayload?.pharmacyStaff?.role?.role]?.slice(1)?.toLowerCase(),
        shift_type: ShiftTypes[(dutyStaffPayload?.shift_type)]?.charAt(0)?.toUpperCase() + ShiftTypes[(dutyStaffPayload?.shift_type)]?.slice(1)?.toLowerCase() + " Shift",  // Shift type or fallback
    }

    useEffect(() => {
        if (!showMember) setSelectedMember(null);
    }, [showMember]);

    return (
        <>
            {(isGetShiftDutyByIdLoading) && <LoadingSpinner fullScreen />}
            {<Box sx={styles.mainHeaderBox}>
                <Box sx={styles.titleBox}>
                    Details of Shift Member
                </Box>
                <Box sx={styles.backButtonBox}>
                    <Typography variant="h6" sx={styles.employeeProfileBackButton}
                        onClick={() => {
                            navigate(SHIFTMANAGEMENT_DASHBOARD_SCREEN_ROUTE);
                        }}
                    >
                        Back
                    </Typography>
                </Box>
            </Box>}
            <Box sx={styles.containerBox}>
                {/* Shift Member Details */}
                {<Box sx={styles.contentBox}>
                    <ShiftMemberDetails
                        bannerDetails={bannerDetails}
                        apiData={filterByWeek}
                        tableData={dataList}
                        selectedMember={selectedMember}
                        setShowMemberState={setShowMember}
                        showMember={showMember}
                    />
                </Box>}
            </Box>
        </>
    );
};

export default ShiftUserScreen;